<template>
  <div class="login_box">
    <!-- 手机端 -->
    <!-- <template v-if="isMobile">
      <div class="mobile-bg tac">
        <div class="top-img">
          <div class="login_logo">
            <el-row class="tac" :gutter="5">
              <el-col class="tar" :span="4">
                <el-image :src="logoSrc"></el-image>
              </el-col>
              <el-col :span="18">
                <div style="height:100%;line-height:60px;color:#fff;">中国文学艺术联合会</div>
              </el-col>
            </el-row>
            <h3 class="tac">视频资源平台</h3>
          </div>
        </div>
        <div class="m-form-box">

          <div v-if="isLogin">
            <div>
              <h4 class="tal mb f16">登录</h4>
              <el-form
                label-position="left"
                class="tal"
                :rules="rulesLogin"
                ref="loginForm"
                label-width="20px"
                :model="loginForm"
              >
                <el-form-item label=" " prop="username">
                  <el-input type="text" v-model="loginForm.username" placeholder="邮箱/手机"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="password">
                  <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="code">
                  <el-row :gutter="4">
                    <el-col :span="12">
                      <el-input
                        v-model="loginForm.code"
                        placeholder="输入验证码"
                        @keyup.enter.native="login('loginForm')"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div @click="init()" class="cursor-poiner">
                        <el-image :src="codeUrl"></el-image>
                      </div>
                    </el-col>

                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-button type="primary" @click="login('loginForm')">登录</el-button>
                    </el-col>
                    <el-col :span="12" class="tac">
                      <div class="cursor-poiner">修改密码</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>

            <div class="vd_reg">
              <p>
                没有账号?
                <span class="cursor-poiner" @click="goRegister">注册账号</span>
              </p>
            </div>
          </div>

          <div v-else>
            <div>
              <h4 class="tal mb">注册</h4>
              <el-form
                label-width="20px"
                label-position="left"
                :rules="rulesLogin"
                ref="registerForm"
                :model="registerForm"
              >
                <el-form-item label=" " prop="email">
                  <el-input clearable v-model="registerForm.email" placeholder="邮箱"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="newPassword">
                  <el-row>
                    <el-input
                      type="password"
                      v-model="registerForm.newPassword"
                      placeholder="6-16位密码，由字母和数字组成"
                      clearable
                      show-password
                    ></el-input>
                  </el-row>
                  <div class="inputmsg">6~16位密码，由字母和数字组成</div>
                </el-form-item>
                <el-form-item label=" " prop="confirmPassword">
                  <el-input
                    show-password
                    clearable
                    type="password"
                    v-model="registerForm.confirmPassword"
                    placeholder="确认密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <el-row :gutter="20">
                    <el-col :span="14">
                      <el-input v-model="registerForm.code" placeholder="输入验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button :disabled="isDisable" @click="getRegisterCode">{{codeName}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-button type="primary" @click="Register">注册</el-button>
                    </el-col>
                    <el-col :span="12">
                      <div @click="goLogin" class="cursor-poiner">使用已有账号登录</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>

          </div>
        </div>
      </div>
    </template>-->
    <template v-if="isMobile">
      <div class="mobile-login">
        <!-- 表单 -->
        <div class="mob-login-form">
          <!-- 登录 -->
          <div v-if="isLogin && findPass == false">
            <div class="login-tab">
                <div ref="mobusername" @click="useUsernameLogin">
                用户名登录
                <span v-if="loginMode == 2" class="tab-bg"></span>
              </div>
               <div ref="mobphone" @click="useIphoneLogin">
                手机号登录
                <span v-if="loginMode == 1" class="tab-bg"></span>
              </div>
              <div style="font-size:22px;font-weight:bold;" ref="mobemail" @click="useEmailLogin">
                邮箱登录
                <span v-if="loginMode == 0" class="tab-bg"></span>
              </div>
  
            </div>
            <el-form
              key="loginForm"
              label-position="left"
              class="tal"
              :rules="rulesLogin"
              ref="loginForm"
              label-width="20px"
              :model="loginForm"
            >
              <el-form-item label=" " prop="username">
                <el-input
                  v-if="loginMode == 0"
                  prefix-icon="el-icon-user"
                  type="text"
                  v-model="loginForm.username"
                  placeholder="邮箱"
                ></el-input>
                <el-input
                  v-else-if="loginMode == 1"
                  prefix-icon="el-icon-user"
                  v-model="loginForm.username"
                  placeholder="请输入手机号"
                ></el-input>
                <el-input
                  v-else
                  prefix-icon="el-icon-user"
                  v-model="loginForm.username"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
              <el-form-item label=" " prop="password">
                <el-input
                  prefix-icon="iconfont iconsuo"
                  type="password"
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item label=" " prop="code">
                <el-row style="line-height:22px;" :gutter="10">
                  <el-col :span="12">
                    <el-input
                      v-model="loginForm.code"
                      placeholder="输入验证码"
                      @keyup.enter.native="login('loginForm')"
                    ></el-input>
                  </el-col>
                  <el-col :span="10">
                    <div @click="init()" class="cursor-poiner">
                      <el-image style="height:100%;vertical-align:center;" :src="codeUrl"></el-image>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <div style="width:100%;">
                  <el-button
                    style="width:100%;background:#00aaff;font-size:18px;"
                    type="primary"
                    round
                    @click="login('loginForm')"
                  >登录</el-button>
                </div>
                <!-- <el-row>
                <el-col :span="12">
                  <el-button type="primary" @click="login('loginForm')">登录</el-button>
                </el-col>
                <el-col :span="12" class="tac">
                  <div class="cursor-poiner">修改密码</div>
                </el-col>
                </el-row>-->
              </el-form-item>
              <el-form-item style="margin-top:50px;">
                <div style="width:100%;">
                  <el-button
                    @click="findPassword"
                    style="width:100%;background:#fff;font-size:18px;"
                    round
                  >找回密码</el-button>
                </div>
                <div>
                  <el-button
                    @click="goRegister"
                    round
                    style="width:100%;background:#fff;font-size:18px;margin-top:10px;"
                  >注册账号</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 注册 -->

          <div v-if="!isLogin && findPass == false">
            <div class="login-tab">
              <div
                style="font-size:22px;font-weight:bold;"
                ref="mobemailReg"
                @click="useEmailRegister"
              >
                邮箱注册
                <span v-if="loginMode == 0" class="tab-bg"></span>
              </div>

              <div ref="mobphoneReg" @click="useIphoneRegister">
                手机号注册
                <span v-if="loginMode == 1" class="tab-bg"></span>
              </div>
            </div>
            <el-form
              key="registerForm"
              label-width="20px"
              label-position="left"
              :rules="rulesLogin"
              ref="registerForm"
              :model="registerForm"
            >
              <el-form-item v-if="loginMode == 0" label=" " prop="email">
                <el-input clearable v-model="registerForm.email" placeholder="邮箱"></el-input>

              </el-form-item>
              <el-form-item v-if="loginMode == 1" label=" " prop="mobile">
                <el-input clearable v-model="registerForm.mobile" placeholder="手机"></el-input>

              </el-form-item>
              <el-form-item label=" " prop="newPassword">
                <el-row>
                  <el-input
                    type="password"
                    v-model="registerForm.newPassword"
                    placeholder="6-16位密码，由字母和数字组成"
                    clearable
                    show-password
                  ></el-input>
                </el-row>
                <div class="inputmsg">6~16位密码，由字母和数字组成</div>
              </el-form-item>
              <el-form-item label=" " prop="confirmPassword">
                <el-input
                  show-password
                  clearable
                  type="password"
                  v-model="registerForm.confirmPassword"
                  placeholder="确认密码"
                ></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <el-row :gutter="20">
                  <el-col :span="14">
                    <el-input v-model="registerForm.code" placeholder="输入验证码"></el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-button :disabled="isDisable" @click="getRegisterCode">{{codeName}}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-button type="primary" @click="Register">注册</el-button>
                  </el-col>
                  <el-col :span="12">
                    <div @click="goLogin" class="cursor-poiner">使用已有账号登录</div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
          <!-- 找回密码 -->
          <div v-if="findPass">
            <a
              href="javascript:;"
              @click="findPass = false"
              style="text-decoration:underline;margin-bottom:20px;color:blue;font-size:16px;"
            >登录</a>
            <el-form
              ref="resetForm"
              :rules="resetRules"
              key="resetForm"
              style="margin-top:20px;"
              :model="resetForm"
            >
              <el-form-item prop="username">
                <el-input v-model="resetForm.username" placeholder="请输入注册时的邮箱/手机号"></el-input>
              </el-form-item>
              <el-form-item>
                <div style="display:flex;flex-direction:row;justify-content:space-between;">
                  <el-input v-model="resetForm.code" style="width:60%;" placeholder="请输入验证码"></el-input>
                  <el-button :disabled="isResetDisable" @click="resetSendCode">{{resetCodeName}}</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="newPassword">
                <el-input show-password v-model="resetForm.newPassword" placeholder="新密码"></el-input>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input show-password v-model="resetForm.confirmPassword" placeholder="确定密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="submitResetPwd"
                  type="primary"
                  round
                  style="width:100%;background:#00aaff;font-size:18px;"
                >提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </template>
    <!-- pc端 -->
    <template v-else>
      <!-- <div class="login_bg tac">
        <div class="vd_login">
          <div class="login_logo">
            <el-row :gutter="5">
              <el-col :span="6">
                <el-image :src="logoPcSrc"></el-image>
              </el-col>
              <el-col :span="18">
                <div style="height:100%;line-height:60px;color:#5bb4e1;">中国文学艺术联合会</div>
              </el-col>
            </el-row>
          </div>
          <h2 class>视频资源平台</h2>

          <div v-if="isLogin">
            <div>
              <h4 class="tal mb">登录</h4>
              <el-form
                label-position="left"
                class="tal"
                :rules="rulesLogin"
                ref="loginForm"
                label-width="20px"
                :model="loginForm"
              >
                <el-form-item label=" " prop="username">
                  <el-input v-model="loginForm.username" placeholder="邮箱/手机"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="password">
                  <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="code">
                  <el-row :gutter="4">
                    <el-col :span="12">
                      <el-input
                        v-model="loginForm.code"
                        placeholder="输入验证码"
                        @keyup.enter.native="login('loginForm')"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div @click="init()" class="cursor-poiner">
                        <el-image :src="codeUrl"></el-image>
                      </div>
                    </el-col>
                    <el-col :span="6">
                  <span class="f12 cursor-poiner" @click="init()">看不清？刷新一下~</span>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-button type="primary" @click="login('loginForm')">登录</el-button>
                    </el-col>
                    <el-col :span="12" class="tac">
                      <div class="cursor-poiner">修改密码</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
            <div class="vd-tab">
              <i class="line-left"></i>
              <span ref="emaillogin" @click="useEmailLogin">使用邮箱登录</span>
              <span ref="iphonelogin" @click="useIphoneLogin">使用手机登录</span>
              <i class="line-right"></i>
            </div>
            <div class="vd_reg">
              <p>
                没有账号?

                <span class="rr cursor-poiner" @click="goRegister">注册账号</span>
              </p>
            </div>
          </div>

          <div v-else>
            <div>
              <h4 class="tal mb">注册</h4>
              <el-form
                label-width="20px"
                label-position="left"
                :rules="rulesLogin"
                ref="registerForm"
                :model="registerForm"
              >
                <el-form-item label=" " prop="email">
                  <el-input clearable v-model="registerForm.email" placeholder="邮箱"></el-input>
                  <el-input v-model="registerForm.mobile" placeholder="手机"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="newPassword">
                  <el-row>
                    <el-input
                      type="password"
                      v-model="registerForm.newPassword"
                      placeholder="6-16位密码，由字母和数字组成"
                      clearable
                      show-password
                    ></el-input>
                  </el-row>
                  <div class="inputmsg">6~16位密码，由字母和数字组成</div>
                </el-form-item>
                <el-form-item label=" " prop="confirmPassword">
                  <el-input
                    show-password
                    clearable
                    type="password"
                    v-model="registerForm.confirmPassword"
                    placeholder="确认密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <el-row :gutter="20">
                    <el-col :span="14">
                      <el-input v-model="registerForm.code" placeholder="输入验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button :disabled="isDisable" @click="getRegisterCode">{{codeName}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-button type="primary" @click="Register">注册</el-button>
                    </el-col>
                    <el-col :span="12">
                      <div @click="goLogin" class="cursor-poiner">使用已有账号登录</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
            <div class="vd-tab">
              <i class="line-left"></i>
              <span ref="emaillogin" @click="useEmailLogin">使用邮箱注册</span>
              <span ref="iphonelogin" @click="useIphoneLogin">使用手机注册</span>
              <i class="line-right"></i>
            </div>
          </div>
        </div>
      </div>-->
      <div class="login_bg tac">
        <div class="vd_login">
          <div class="login_left"></div>
          <div class="login_right">
            <!-- 表单 -->
            <!-- 登录 -->
            <template v-if="isLogin && findPass == false">
              <div class="right_nav">
                <div style="border-bottom: 4px solid #00aaff" ref="usernamelogin" @click="useUsernameLogin" class="f16 font-weight">用户名登录</div>
                <div ref="iphonelogin" @click="useIphoneLogin" class="f16 font-weight">手机号登录</div>

                <div
                  ref="emaillogin"
                  @click="useEmailLogin"
                  class="f16 font-weight"
                >邮箱登录</div>
              </div>
              <div style="padding:20px;">
                <el-form
                  key="loginForm"
                  label-position="left"
                  class="tal"
                  :rules="rulesLogin"
                  ref="loginForm"
                  label-width="20px"
                  :model="loginForm"
                >
                  <el-form-item label=" " prop="username">
                    <el-input
                      v-if="loginMode == 0"
                      prefix-icon="el-icon-user"
                      v-model="loginForm.username"
                      placeholder="请输入邮箱"
                    ></el-input>
                    <el-input
                      v-else-if="loginMode == 1"
                      prefix-icon="el-icon-user"
                      v-model="loginForm.username"
                      placeholder="请输入手机号"
                    ></el-input>
                    <el-input
                      v-else
                      prefix-icon="el-icon-user"
                      v-model="loginForm.username"
                      placeholder="请输入用户名"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item v-if="loginMode == 1" prop="username">
                    <el-input
                      prefix-icon="el-icon-user"
                      v-model="loginForm.username"
                      placeholder="请输入手机号"
                  ></el-input>-->
                  <!-- </el-form-item> -->
                  <el-form-item label=" " prop="password">
                    <el-input
                      prefix-icon="el-icon-lock"
                      type="password"
                      v-model="loginForm.password"
                      show-password
                      placeholder="请输入密码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label=" " prop="code">
                    <el-row :gutter="4">
                      <el-col :span="13">
                        <el-input
                          v-model="loginForm.code"
                          placeholder="输入验证码"
                          @keyup.enter.native="login('loginForm')"
                        ></el-input>
                      </el-col>
                      <el-col :span="10">
                        <div @click="init()" class="cursor-poiner img-code">
                          <el-image
                            style="height:100%;width:100%;vertical-align:center;"
                            class
                            :src="codeUrl"
                          ></el-image>
                        </div>
                      </el-col>
                      <!-- <el-col :span="6">
                  <span class="f12 cursor-poiner" @click="init()">看不清？刷新一下~</span>
                      </el-col>-->
                    </el-row>
                  </el-form-item>
                  <el-form-item style="margin-bottom:20px;margin-top:-10px;">
                    <div class="cursor-poiner font-weight" style="color:#79d3ff;text-align:left;">
                      <span @click="findPassword">找回密码</span>
                    </div>
                  </el-form-item>

                  <el-form-item>
                    <el-row>
                      <el-button
                        style="width:100%;background:#00aaff;font-size:18px;"
                        type="primary"
                        @click="login('loginForm')"
                      >登录</el-button>
                      <!-- <el-col :span="12" class="tac">
                      <div class="cursor-poiner">修改密码</div>
                      </el-col>-->
                    </el-row>
                  </el-form-item>
                </el-form>
              </div>
              <!--  -->
              <div class="vd_reg">
                <p>
                  没有账号?
                  <span
                    class="rr cursor-poiner"
                    style="color:#08adff;"
                    @click="goRegister"
                  >注册账号</span>
                </p>
              </div>
            </template>
            <!-- 找回密码 -->
            <template v-if="findPass">
              <div class="tal" @click="back" style="cursor:pointer;">&lt;&lt;返回</div>
              <!-- <router-link :to="$router.back()">&lt;&lt;返回</router-link> -->
              <h3 style="padding:10px;">重置密码</h3>
              <div></div>
              <el-form ref="resetForm" :rules="resetRules" key="resetForm" :model="resetForm">
                <el-form-item prop="username">
                  <el-input v-model="resetForm.username" placeholder="请输入注册时的邮箱/手机号"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="display:flex;flex-direction:row;justify-content:space-between;">
                    <el-input v-model="resetForm.code" style="width:60%;" placeholder="请输入验证码"></el-input>
                    <el-button :disabled="isResetDisable" @click="resetSendCode">{{resetCodeName}}</el-button>
                  </div>
                </el-form-item>
                <el-form-item prop="newPassword">
                  <el-input
                    type="password"
                    show-password
                    v-model="resetForm.newPassword"
                    placeholder="新密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="confirmPassword">
                  <el-input
                    type="password"
                    show-password
                    v-model="resetForm.confirmPassword"
                    placeholder="确定密码"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    @click="submitResetPwd"
                    type="primary"
                    style="width:100%;background:#00aaff;font-size:18px;"
                  >提交</el-button>
                </el-form-item>
              </el-form>
            </template>
            <!-- 注册 -->
            <template v-if="!isLogin && findPass == false">
              <div class="right_nav">
                <div
                  style=" border-bottom: 4px solid #00aaff"
                  ref="emailReg"
                  @click="useEmailRegister"
                  class="f20 font-weight"
                >邮箱注册</div>
                <div ref="iphoneReg" @click="useIphoneRegister" class="f20 font-weight">手机号注册</div>
              </div>
              <el-form
                label-width="20px"
                label-position="left"
                :rules="rulesLogin"
                ref="registerForm"
                :model="registerForm"
              >
                <el-form-item v-if="loginMode == 0" label prop="email">
                  <el-input type="email" clearable v-model="registerForm.email" placeholder="邮箱"></el-input>
                  <!-- <el-input v-else v-model="registerForm.mobile" placeholder="手机"></el-input> -->
                </el-form-item>
                <el-form-item v-if="loginMode == 1" prop="mobile">
                  <el-input v-model="registerForm.mobile" placeholder="手机"></el-input>
                </el-form-item>
                <el-form-item label=" " prop="newPassword">
                  <el-row>
                    <el-input
                      type="password"
                      v-model="registerForm.newPassword"
                      placeholder="6-16位密码，由字母和数字组成"
                      clearable
                      show-password
                    ></el-input>
                  </el-row>
                  <!-- <div class="inputmsg">6~16位密码，由字母和数字组成</div> -->
                </el-form-item>
                <el-form-item label=" " prop="confirmPassword">
                  <el-input
                    show-password
                    clearable
                    type="password"
                    v-model="registerForm.confirmPassword"
                    placeholder="确认密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <el-row :gutter="20">
                    <el-col :span="14">
                      <el-input v-model="registerForm.code" placeholder="输入验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button :disabled="isDisable" @click="getRegisterCode">{{codeName}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item>
                  <el-button
                    style="width:100%;background:#00aaff;font-size:18px;"
                    type="primary"
                    @click="Register"
                  >注册</el-button>
                </el-form-item>
                <el-form-item>
                  <div
                    @click="goLogin"
                    style="color:#02abff;font-size:16px;"
                    class="cursor-poiner"
                  >使用已有账号登录</div>
                </el-form-item>
              </el-form>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import common from '../../utils/common.utils'

import qs from 'qs'
export default {
  data: function () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        // if (this.registerForm.confirmPassword !== "") {
        this.registerForm.confirmPassword.replace(/[\d]/g, '')
        var patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
        if (patrn.test(this.registerForm.newPassword)) {
          // this.$refs.registerForm.validateField("confirmPassword");
          callback()
        } else {
          callback(new Error('密码未达到要求，至少一个数字、一个字母，6~16个字符'))
        }
        // }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      // console.log(value);
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    var resetPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        // if (this.resetForm.confirmPassword !== "") {
        this.resetForm.confirmPassword.replace(/[\d]/g, '')
        var patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
        if (patrn.test(value)) {
          this.$refs.resetForm.validateField('confirmPassword')
          callback()
        } else {
          callback('密码未达到要求，6~16个字符,至少一个数字、一个字母，')
        }
        // }
      }
    }
    var resetPass2 = (rule, value, callback) => {
      console.log(value)
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    // 手机号格式
    var mobilePass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'))
      } else {
        var part = /^\d{11}$/
        if (part.test(this.registerForm.mobile)) {
          callback()
        } else {
          callback(new Error('手机号格式错误'))
        }
      }
    }
    // 邮箱格式
    var emailPass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入邮箱'))
      } else {
        var patrn = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
        if (patrn.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }
    }
    // 登录格式
    var usernameValidate = (rule, value, callback) => {
      // console.log(rule);
      console.log(value)
      if (this.loginMode == 0) {
        if (value == '') {
          callback(new Error('请输入邮箱'))
        } else {
          console.log(value)
          var patrn = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
          if (patrn.test(value)) {
            callback()
          } else {
            callback(new Error('邮箱格式不正确'))
          }
        }
      } else if (this.loginMode == 1) {
        if (value == '') {
          callback(new Error('请输入手机号'))
        } else {
          var part = /^\d{11}$/
          if (part.test(value)) {
            callback()
          } else {
            callback(new Error('手机号格式错误'))
          }
        }
      } else {
        // 用户名
        if (value == '') {
          callback(new Error('请输入用户名'))
        } else {
          var pattern = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/
          if (pattern.test(value)) {
            callback()
          } else {
            callback(new Error('请输入字母、数字组合'))
          }
        }
      }
    }
    // 重置密码
    var resetPsw = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请填写注册时的邮箱/手机号'))
      } else {
        // 手机号
        var mob = /^\d{11}$/
        // 邮箱
        var emailPatrn = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
        if (mob.test(value)) {
          this.isReset = 0
          console.log('手机重置密码')
          callback()
        } else if (emailPatrn.test(value)) {
          console.log('邮箱重置密码')
          this.isReset = 1
          callback()
        } else {
          callback(new Error('邮箱/手机号格式不对'))
        }
      }
    }
    return {
      isReset: 0,
      // deviceWidth: document.documentElement.clientWidth || window.innerWidth,
      // deviceWidth:window.innerWidth,
      loginMode: 2, // 邮箱手机 0邮箱 1手机 2用户名 注册/登录
      findPass: false,
      isMobile: false,
      logoPcSrc: require('../../assets/img/logo.jpg'),
      logoSrc: require('../../assets/img/logo2.png'),
      isLogin: true,
      captchaId: '',
      codeUrl: '',
      loginForm: {
        username: '', // 手机号/邮箱
        password: '',
        captchaId: '', // 验证码id
        code: '',
        type: 2 // 1=邮箱、0=手机号、2=用户名
      },
      rulesLogin: {
        username: [
          {
            required: true,
            validator: usernameValidate,
            // message: "格式不正确",
            trigger: 'blur'
          }
          // { required: true, message: "请输入邮箱", trigger: "blur" }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: emailPass, trigger: ['blur'] }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: mobilePass, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: ['blur'] }

        ],
        confirmPassword: [
          { validator: validatePass2, trigger: ['blur', 'change'] }
        ]
      },
      // 【注册】
      registerForm: {
        email: '',
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      },

      // 倒计时
      isDisable: false,
      isResetDisable: false,
      codeName: '发送验证码',
      resetCodeName: '发送验证码',
      num: '60',
      rnum: '60',
      backPath: '',
      // 找回密码
      resetForm: {
        username: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      },
      resetRules: {
        username: [{ required: true, validator: resetPsw, trigger: ['blur'] }],
        newPassword: [
          { validator: resetPass, trigger: 'blur' },
          {
            min: 6,
            max: 16,
            message: '长度 6 到 16 个字符,由字母和数字组成',
            trigger: ['blur', 'change']
          }
        ],
        confirmPassword: [
          { validator: resetPass2, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    back: function () {
      this.findPass = false
      this.loginMode = 0
    },
    clearForm: function () {
      this.registerForm.mobile = ''
      this.registerForm.email = ''
      this.registerForm.newPassword = ''
      this.registerForm.confirmPassword = ''
      this.registerForm.code = ''
      setTimeout(() => {
        this.clearValidate('registerForm')
      }, 50)
    },
    // 找回密码
    findPassword: function () {
      this.findPass = true
    },
    // 手机重置
    IphoneSubmit: async function () {
      // 手机
      var res = await this.$http.post(
        `/v1/bqUser/resetMobile`,
        qs.stringify(this.resetForm)
      )
      var { code, data, message } = res.data
      if (code == 0) {
        this.$message.success('密码重置成功！即将返回登录页')
        this.resetForm = {}
        this.isLogin = true
        this.findPass = false
      } else {
        this.$message.error(message)
      }
    },
    // 邮箱重置
    EmailSubmit: async function () {
      var res = await this.$http.post(
        `/v1/bqUser/reset`,
        qs.stringify(this.resetForm)
      )
      var { code, data, message } = res.data
      if (code == 0) {
        this.$message.success('密码重置成功！即将返回登录页')
        this.isLogin = true
        this.findPass = false
        this.resetForm = {}
      } else {
        this.$message.error(message)
      }
    },
    submitResetPwd: async function () {
      if (this.isReset == 0) {
        // 手机
        this.IphoneSubmit()
      } else {
        // 邮箱
        this.EmailSubmit()
      }
    },
    // 手机获取验证码
    sendIphoneCode: async function () {
      var res = await this.$http.get(
        `/v1/captcha/resetSmsCode?mobile=${this.resetForm.username}`
      )
      var { code, data, message } = res.data
      if (code == 0) {
        this.$message.success('验证码已发送至手机')
        this.setResetTime()
      } else {
        this.$message.error(message)
      }
    },
    // 邮箱获取验证码
    sendEmailCode: async function () {
      var res = await this.$http.get(
        `/v1/captcha/getResetEmailVcodeUnLogin?email=${this.resetForm.username}`
      )
      var { code, data, message } = res.data
      console.log(res)
      if (code == 0) {
        this.$message.success('验证码已发送至邮箱！')

        this.setResetTime()
      } else {
        this.$message.error(message)
      }
    },
    resetSendCode: function () {
      //  this.$refs.registerForm.validate(async valid => {
      //   if (valid) {
      if (this.isReset == 0) {
        this.sendIphoneCode()
      } else {
        this.sendEmailCode()
      }

      //   }
      // });
    },
    // 清除表单校验
    clearValidate (formName) {
      this.$refs[formName].clearValidate()
    },
    //   初始化图形验证码
    init: async function () {
      var res = await this.$http.get('/v1/captcha/init')
      var { code, data } = res.data
      if (code == 0) {
        this.captchaId = data
        this.loginForm.captchaId = data
      }
    },
    getDraw: async function () {
      if (this.captchaId) {
        var data = await this.$http.get(
          `/v1/captcha/draw?captchaId=${this.captchaId}`,
          { responseType: 'arraybuffer' }
        )
        var src =
          'data:image/png;base64,' +
          btoa(
            new Uint8Array(data.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
          )
        this.codeUrl = src
        // console.log(src);
      }
    },
    // 登录
    login: function () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `/v1/bqUser/login`,
            qs.stringify(this.loginForm)
          )

          var { code, message, data } = res.data
          if (code == 0) {
            if (this.isMobile) {
              this.$layer.toast({
                icon: 'icon-check', // 图标clssName 如果为空 toast位置位于下方,否则居中
                content: '登录成功',
                time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
              })
            } else {
              this.$message({
                message: message,
                type: 'success',
                duration: '1000'
              })
            }

            // console.log('userInfo:', data)
            window.localStorage.setItem('token', data.token)
            window.localStorage.setItem('userInfo', data.user)
            window.localStorage.setItem('userName', data.user.username)
            window.localStorage.setItem('userid',data.user.roleid)
            // window.sessionStorage.setItem('token', data.token)
            // window.sessionStorage.setItem('userInfo', data.user)
            // window.sessionStorage.setItem('userName', data.user.username)
            this.$store.state.token = data.token
            this.$store.state.userInfo = data.user
            if (this.backPath && this.$route.query.backpath == undefined) {
              this.$router.push(this.backPath)
            } else {
              this.$router.push('/home')
            }
          } else {
            if (this.isMobile) {
              this.$layer.toast({
                content: message,
                time: '2000'
              })
            } else {
              this.$message.error(message)
            }
            this.init()
          }
        }
      })
    },
    goRegister: function () {
      this.isLogin = false
      this.clearValidate('loginForm')
      // this.clearValidate("registerForm")
    },
    useEmailLogin: function () {
      this.init()
      // console.log(this.$refs.emaillogin)
      this.loginForm = {
        username: '', // 手机号/邮箱
        password: '',
        captchaId: '', // 验证码id
        code: '',
        type: 1
      }
      if (this.isMobile) {
        this.$refs.mobemail.style = 'font-size:22px;font-weight:bold;'
        this.$refs.mobphone.style = 'font-size:18px;font-weight:none;'
        this.$refs.mobusername.style = 'font-size:18px;font-weight:none;'
      } else {
        this.$refs.emaillogin.style = ' border-bottom: 4px solid #00aaff'
        this.$refs.iphonelogin.style = 'border-bottom: 4px solid #fff'
        this.$refs.usernamelogin.style = 'border-bottom: 4px solid #fff'
      }
      this.loginMode = 0
      this.clearValidate('loginForm')
      // this.clearValidate("registerForm");
    },
    useIphoneLogin: function () {
      this.init()
      this.loginForm = {
        username: '', // 手机号/邮箱
        password: '',
        captchaId: '', // 验证码id
        code: '',
        type: 0
      }
      this.loginMode = 1
      if (this.isMobile) {
        this.$refs.mobphone.style = 'font-size:22px;font-weight:bold;'
        this.$refs.mobemail.style = 'font-size:18px;font-weight:none;'
        this.$refs.mobusername.style = 'font-size:18px;font-weight:none;'
      } else {
        this.$refs.iphonelogin.style = ' border-bottom: 4px solid #00aaff'
        this.$refs.emaillogin.style = 'border-bottom: 4px solid #fff'
        this.$refs.usernamelogin.style = 'border-bottom: 4px solid #fff'
      }

      this.clearValidate('loginForm')
      // this.clearValidate("registerForm");
    },
    useUsernameLogin: function () {
      this.init()
      this.loginForm = {
        username: '', // 手机号/邮箱
        password: '',
        captchaId: '', // 验证码id
        code: '',
        type: 2
      }
      this.loginMode = 2
      if (this.isMobile) {
        this.$refs.mobphone.style = 'font-size:18px;font-weight:none;'
        this.$refs.mobemail.style = 'font-size:18px;font-weight:none;'
        this.$refs.mobusername.style = 'font-size:22px;font-weight:bold;'
      } else {
        this.$refs.iphonelogin.style = ' border-bottom: 4px solid #fff'
        this.$refs.emaillogin.style = 'border-bottom: 4px solid #fff'
        this.$refs.usernamelogin.style = 'border-bottom: 4px solid #00aaff'
      }
      this.clearValidate('loginForm')
    },
    // 注册
    useEmailRegister: function () {
      this.loginMode = 0
      // registerForm: {
      //   email: "",
      //   mobile: "",
      //   newPassword: "",
      //   confirmPassword: "",
      //   code: ""
      // },
      this.registerForm = {
        email: '',
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      }
      setTimeout(() => {
        this.clearValidate('registerForm')
      }, 50)
      this.num = '1'
      this.codeName = '获取验证码'
      this.isDisable = false
      if (this.isMobile) {
        this.$refs.mobemailReg.style = 'font-size:22px;font-weight:bold;'
        this.$refs.mobphoneReg.style = 'font-size:18px;font-weight:none;'
      } else {
        this.$refs.iphoneReg.style = ' border-bottom: 4px solid #fff'
        this.$refs.emailReg.style = 'border-bottom: 4px solid #00aaff'
      }
    },
    useIphoneRegister: function () {
      this.num = '1'
      this.codeName = '获取验证码'
      this.isDisable = false
      this.loginMode = 1
      this.registerForm = {
        email: '',
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      }
      setTimeout(() => {
        this.clearValidate('registerForm')
      }, 50)

      if (this.isMobile) {
        this.$refs.mobphoneReg.style = 'font-size:22px;font-weight:bold;'
        this.$refs.mobemailReg.style = 'font-size:18px;font-weight:none;'
      } else {
        this.$refs.iphoneReg.style = ' border-bottom: 4px solid #00aaff'
        this.$refs.emailReg.style = 'border-bottom: 4px solid #fff'
      }
    },
    setTime () {
      console.log(this.num)
      if (this.num == 1) {
        this.codeName = '获取验证码'
        this.isDisable = false
        this.num = '60'
        return
      } else {
        this.codeName = '重新获取(' + this.num + 's)'
        this.isDisable = true
        this.num--
        // console.log(this.num);
      }
      setTimeout(() => {
        this.setTime()
      }, 1000)
    },
    setResetTime () {
      if (this.rnum == 1) {
        this.resetCodeName = '获取验证码'
        this.isResetDisable = false
        this.rnum = '60'
      } else {
        this.resetCodeName = '重新获取(' + this.rnum + 's)'
        this.isResetDisable = true
        this.rnum--

        // console.log(this.num);
        setTimeout(() => {
          this.setResetTime()
        }, 1000)
      }
    },
    getRegisterCode: function () {
      if (this.loginMode == 0) {
        this.$refs.registerForm.validate(async valid => {
          if (valid) {
            var res = await this.$http.get(
              `/v1/captcha/getRegisterEmailVcodeUnLogin?email=${this.registerForm.email}`
            )
            var { code, data, message } = res.data
            console.log(res)
            if (code == 0) {
              this.$message.success('验证码已发送至邮箱！')
              this.num = 60
              this.setTime()
            } else {
              this.$message.error(message)
            }
          }
        })
      } else {
        this.$refs.registerForm.validate(async valid => {
          if (valid) {
            var res = await this.$http.get(
              `/v1/captcha/sendSmsCode?mobile=${this.registerForm.mobile}`
            )
            var { code, data, message } = res.data
            console.log(res)
            if (code == 0) {
              this.$message.success('验证码已发送至手机！')
              this.num = 60
              this.setTime()
            } else {
              this.$message.error(message)
            }
          }
        })
      }
    },
    Register: function () {
      if (this.loginMode == 0) {
        // 邮箱
        this.$refs.registerForm.validate(async valid => {
          // console.log('111111')
          if (valid) {
            // console.log('rrrrr')
            var res = await this.$http.post(
              `/v1/register/emailRegister`,
              qs.stringify(this.registerForm)
            )
            var { code, data, message } = res.data
            console.log(res)
            if (code == 0) {
              this.$message.success('注册成功！即将跳转登录页面！')
              this.clearForm()
              setTimeout(() => {
                this.isLogin = true
              }, 1000)
              console.log(res)
            } else {
              this.$message.error(message)
            }
          } else {
            this.$message.error('请校验规则')
          }
        })
      } else {
        this.$refs.registerForm.validate(async valid => {
          // console.log('111111')
          if (valid) {
            // console.log('rrrrr')
            var res = await this.$http.post(
              `/v1/register/mobileRegister`,
              qs.stringify(this.registerForm)
            )
            var { code, data, message } = res.data
            console.log(res)
            if (code == 0) {
              this.$message.success('注册成功！即将跳转登录页面！')
              this.clearForm()
              setTimeout(() => {
                this.isLogin = true
              }, 1000)

              console.log(res)
            } else {
              this.$message.error(message)
            }
          } else {
            this.$message.error('请校验规则')
          }
        })
      }
    },
    // 跳转到登录
    goLogin: function () {
      this.isLogin = true
      this.clearValidate('registerForm')
      this.registerForm = {
        email: '',
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      }
      // this.clearValidate("loginForm");
    }
  },
  mounted: function () {
    document.querySelector('#app').scrollIntoView(true)
    this.init()
    this.isMobile = common._isMobile()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.backPath = from.fullPath
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log(from.path)
    next()
  },
  watch: {
    captchaId: function () {
      if (this.captchaId !== '') {
        this.getDraw()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mobile/mobilelogin.scss";
.login_box {
  height: 100%;
  width: 100%;
}
.login_bg {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url("../../assets/img/logobg.png") no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
// ----登录注册
.vd_login {
  position: absolute;
  width: 800px;
  height: 550px;
  // line-height: 440px;
  // background-color: #fff;
  // padding: 30px 60px 0 60px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  display: flex;
  .login_left {
    width: 350px;
    height: 100%;
    background: url("../../assets/img/loginleft.png") no-repeat;
    background-size: cover;
  }
  .login_right {
    flex: 1;
    height: 531px;
    margin-top: 10px;
    background-color: #fff;
    border-radius: 0 10px 10px 0px;
    box-shadow: 0 0 2px #000;
    padding: 50px 57px 29px;
    .right_nav {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin-bottom: 15px;
      div {
        border-bottom: 4px solid #fff;
      }
      div:hover {
        cursor: pointer;
        border-bottom: 4px solid #00aaff;
      }
    }
  }
  // 邮箱/手机
  .vd-tab {
    position: absolute;
    bottom: 60px;
    text-align: center;
    width: 400px;
    //   border-top: 1px solid #ccc;
    .line-left {
      position: absolute;
      left: 0px;
      width: 48px;
      height: 1px;
      background-color: #ccc;
    }
    .line-right {
      position: absolute;
      right: 0px;
      width: 48px;
      height: 1px;
      background-color: #ccc;
    }
    span {
      display: inline-block;
      border: 1px solid #ccc;
      // border-top: none;
      font-size: 12px;
      width: 150px;
      background-color: #f5f5f5;
      padding: 8px;
      &:hover {
        background-color: #fff;
        color: #409eff;
        cursor: pointer;
        border-top: none;
      }
    }
  }
}
@media screen and(-ms-high-contrast:active), (-ms-high-contrast: none) {
  .img-code {
    .el-image {
      overflow: visible !important;
      margin-top: 20px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue